import { appLocalStorage } from '@/utils';
import { IMessage, ISavedMessage, mapFromUserHistory, mapToUserHistory, MAX_MESSAGES_COUNT, MESSAGES_KEY } from '../helpers';
import { useEffect, useMemo, useState } from 'react';

export const useMessages = () => {
  const [messages, setMessages] = useState<IMessage[]>(() =>
    mapFromUserHistory(appLocalStorage.getItem<ISavedMessage[]>(MESSAGES_KEY) ?? []).slice(-MAX_MESSAGES_COUNT)
  );

  useEffect(() => {
    appLocalStorage.setItem(MESSAGES_KEY, mapToUserHistory(messages.slice(-MAX_MESSAGES_COUNT)));
  }, [messages]);

  return useMemo(() => ({ messages, setMessages }), [messages]);
};
